import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg width={12} height={2} viewBox="0 0 12 2" fill="none" {...props}>
      <Path d="M11 1H1" stroke="#fff" strokeWidth={2} strokeLinecap="round" />
    </Svg>
  );
}

export default SvgComponent;
